import Vue from 'vue'
import Vuex from 'vuex'
import Storage from './storage' // 引入封装的storage.js
//vuex数据管理仓库
Vue.use(Vuex)

//import {FETCHLIST,} from './mutation-types';
import axios from 'axios'

const key = 'user'
const isLogin = 'isLogin'
var store = new Vuex.Store({
  //	strict:true,
  state: {
    city: '正在定位',
    citys: '正在定位',
    validTimes: '0',
    balance: 0,
    city_id: '',
    city_ids: '',
    loginStatus: 0,
    q_url: 'https://www.dongshanhaibao.com/verify_output.htm',
    //q_url:'http://tj.dshb.ilmgj.com/verify_output.htm',
    kf_url: 'https://dongshanyihai.kf5.com/kchat/46228?from=%E5%9C%A8%E7%BA%BF%E6%94%AF%E6%8C%81',
    cart_list: [],
    show_id: '',
    show_id_two: '',
    cardDate: '',
    search_value: '',
    hidePriceid: 1285, //特殊专区隐藏价格1285
    payment0: 1259, //o元可支付1259
    hidefestival: [1420, 1433], //首页隐藏价格专区id
    hidefestivalflId: [5775, 5804], //首页隐藏价格分类id
    lb_cityId: Storage.get('lb_cityId') || '',
    festival_cityList: Storage.get('festival_cityList') || ''
  },
  mutations: {
    // setProducts (state, products) {
    //     state.spzk = products
    // }
    setFestivalCityId(state, val) {
      Storage.set('lb_cityId', val === null ? '' : val)
      state.lb_cityId = val
    },
    setCityList(state, val) {
      Storage.set('festival_cityList', val === null ? '' : val)
      state.festival_cityList = val
    }
  }
  //	actions: {
  //	    getAllProducts ({ commit }, payload) {
  //	    	axios.get('/tld/obtain_web_set.htm').then((res)=>{
  //	    		console.log(res)
  //				commit('setProducts', res.data.resultData)
  //			})
  //
  //	    }
  //	}
})
export default store
